import { useCallback } from 'react';
import { getMeta } from '@helpcenter/meta';
import { di } from 'react-magnetic-di';

import { fetchJson } from '@atlassian/help-center-common-util/fetch/fetch';
import { useService } from '@atlassian/help-center-common-util/use-service';

import { useProjectId, useRequestTypeId } from '../../controllers/request-create-context-provider';
import { APOLLO_STARGATE_URL_PREFIX } from '../constants';
import type { KnowledgeBaseSearchRequest, KnowledgeBaseSearchResponse } from './types';

export type { KnowledgeBaseSearchRequest } from './types';

export const useKnowledgeBaseSearchService = () => {
	di(useProjectId, useRequestTypeId);
	const projectId = useProjectId();
	const requestTypeId = useRequestTypeId();

	const request = useCallback(
		({ labels, query, resultLimit }: KnowledgeBaseSearchRequest) => {
			const activationId = getMeta('activation-id') as string;

			const params = new URLSearchParams();
			if (labels) {
				labels.forEach((label) => params.append('labels', label));
			}
			params.set('searchQuery', query);
			params.set('limit', String(resultLimit));
			const queryString = params.toString();

			let uri: string;
			if (requestTypeId) {
				uri = `${APOLLO_STARGATE_URL_PREFIX}/${activationId}/api/jsm-portal/project/${projectId}/request-type/${requestTypeId}/articles?${queryString}`;
			} else {
				uri = `${APOLLO_STARGATE_URL_PREFIX}/${activationId}/api/jsm-portal/project/${projectId}/articles?${queryString}`;
			}

			return fetchJson<KnowledgeBaseSearchResponse>(uri, {
				method: 'GET',
				headers: { 'Content-Type': 'application/json' },
			});
		},
		[projectId, requestTypeId],
	);

	return useService(request);
};
